(() => {
  if (window.netlensContactLensSpecsHelpReady) return;
  window.netlensContactLensSpecsHelpReady = true;

  const selector = '[data-netlens-contact-lens-specs] .nl-specs__help-button';

  function closeHelp(button, restoreFocus = false) {
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;

    button.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    if (restoreFocus) button.focus();
  }

  function closeOtherHelp(activeButton) {
    document.querySelectorAll(`${selector}[aria-expanded="true"]`).forEach((button) => {
      if (button !== activeButton) closeHelp(button);
    });
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest(selector);

    if (button) {
      const panelId = button.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      const willOpen = button.getAttribute('aria-expanded') !== 'true';

      closeOtherHelp(button);
      button.setAttribute('aria-expanded', String(willOpen));
      if (panel) panel.hidden = !willOpen;
      return;
    }

    if (!event.target.closest('.nl-specs__help')) closeOtherHelp(null);
  });

  document.addEventListener('keydown', (event) => {
    const button = event.target.closest?.(selector);

    if (button && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      button.click();
      return;
    }

    if (event.key !== 'Escape') return;

    const openButton = document.querySelector(`${selector}[aria-expanded="true"]`);
    if (openButton) {
      event.preventDefault();
      closeHelp(openButton, true);
    }
  });
})();

